export const mainContentCss = "mzkbci2";
export const pageHeaderCss = "p8j4utf";
export const settingsCss = "s1xrnlh8";
export const sectionCss = "s7x1ng1";
export const sectionHeaderCss = "s1c7ph4f";
export const dividerCss = "d1sm1uv2";
export const fieldGroupCss = "fgmbgrx";
export const compactFieldStackCss = "c1pvzonu";

/* Figma: Minimum notice / Start interval use 4px label→control gap */
export const compactFieldGroupCss = "cnhf4e3";
export const fieldHelperCss = "f1p1akl";

/*
 * Figma 2587:280975 Minimum notice row (node Frame 11):
 * flex, gap spacing0_5x, width 346px
 * Text input 127×40 (px spacing0_75x, py spacing0_5x) + Select flex-1
 * Two separate bordered fields — not a compound shell.
 */
export const minimumNoticeRowCss = "mqosvxg";
export const minimumNoticeNumberFieldCss = "mpfdgv9";
export const minimumNoticeUnitSelectCss = "mrcxsu4";
export const startIntervalFieldCss = "s169mcln";
export const dateRangeDetailCss = "d8l8x35";
export const fixedDateRangeInputCss = "fulkkhj";
export const rollingDaysRowCss = "r1ezdc3i";

/* Figma ViewSwitcher: tertiary track, no border; selected = white + soft elevation shadow.
   Target CUI data attribute so overrides stick against linaria styled rules. */
export const dateRangeSwitchCss = "dbxmty3";

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");